"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegexConstants = void 0;
exports.RegexConstants = {
    NotSSN: /[^\d-]/,
    NotPercentage: /[^\d+(.,\d+)]/,
    NotPercentageWithCommas: /[^\d+(,\d+)]/,
    NotNumber: /[^\d]/g,
    IcelandicMobilePhoneNr: /^[678][0-9]{2}-?[0-9]{4}$/,
    NotIcelandicPhoneNrCode: /^354/,
    NotLeadingZeros: /^0+/g,
    Cookie: '=([^;]+)',
    Dash: /-/g,
    AlphanumCharacters: /\w\S*/g,
    Number: /^\d+$/,
    IsBase64: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/,
    Emoji: /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}]/u,
    AlphanumSpecialAndIcelandicCharacters: /^[0-9a-zA-Z\sÁáÐðÉéÍíÓóÚúÝýÞþÆæÖö!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
    BankAccountNumber: /^[0-9-]+$/,
};
//# sourceMappingURL=Regex.js.map